import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const PREVIEW = [
  { q: "What about my roof?", a: "Mounts are attached to structural roof members per engineering and installation requirements, and workmanship is covered by a 10-year written warranty. Roofs that are older or in poor condition may need repair before installation." },
  { q: "What if I sell my home?", a: "The ION Solar agreement may be assumable by an eligible buyer. All applicable warranties and guarantees are inherited by the new homeowner." },
  { q: "Who insures the system?", a: "We maintain ownership and liabilities of the system, therefor we insure the system." },
  { q: "What if production falls short?", a: "You're purchasing the production — not the panels. Eligible shortfalls may receive compensation per the signed agreement's production-guarantee terms." },
];

export default function FAQPreview() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="faq-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4">
          <div className="eyebrow">Homeowner Questions</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-4xl font-semibold text-[#0F382C] leading-tight">
            The questions I hear most often.
          </h2>
          <p className="mt-4 text-slate-600">
            Short answers below. The full roof, warranty, moving, insurance, and installation detail lives on the Homeowner Questions page.
          </p>
          <Link
            to="/homeowner-questions"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#B45309] hover:text-[#0F382C]"
            data-testid="faq-preview-link"
          >
            See every homeowner question <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="card-warm p-4 md:p-6" data-testid="faq-preview-accordion">
            {PREVIEW.map((f, i) => (
              <AccordionItem key={i} value={`p-${i}`} className="border-b border-[#E5E0D8] last:border-b-0">
                <AccordionTrigger className="font-serif-display text-lg text-[#0F382C] hover:no-underline text-left" data-testid={`faq-preview-q-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
